var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9 12C22.9 5.9801 18.0199 1.10001 12 1.10001H11.1V12.9H22.9V12ZM12.9 2.94395C17.2073 3.36682 20.6332 6.79275 21.0561 11.1H12.9V2.94395Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34375 3.24608L9.33557 3.25074L8.51702 3.59015C7.40544 4.05108 6.40422 4.72649 5.56533 5.56538C3.91757 7.21316 2.9 9.48694 2.9 12.0001C2.9 17.0258 6.9742 21.1001 12 21.1001C14.5119 21.1001 16.7848 20.0834 18.4323 18.437L18.7422 18.1172L18.7461 18.1133L18.7575 18.0949C19.4478 17.3302 20.0097 16.4482 20.4099 15.483L20.7546 14.6517L22.4173 15.3411L22.0726 16.1725C21.5199 17.5055 20.7108 18.7042 19.7074 19.7075L19.7047 19.7032L19.7036 19.7036L19.7074 19.7075C17.7359 21.679 15.0097 22.9001 12 22.9001C5.98009 22.9001 1.1 18.02 1.1 12.0001C1.1 8.99037 2.32101 6.26414 4.29253 4.29259C5.29587 3.28925 6.49456 2.48017 7.82757 1.92743L8.65893 1.5827L9.34762 3.24357L9.34375 3.24608Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56533 5.56538L5.57329 5.56049L5.57031 5.5625L5.57245 5.5725L5.56533 5.56538Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/split.3e66e06ff0364b5b1b5a94d890bb12fb.svg";
export { ForwardRef as ReactComponent };